import { useEffect, useState } from "react";
import StatsCard from "../../Global/StatsCard";
import {
  UserGroupIcon,
  CursorArrowRippleIcon,
  ArrowLeftStartOnRectangleIcon,
} from "@heroicons/react/24/outline";
import SkeletonCard from "../../Skeleton/SkeletonCard";
import cdpService from "../../../apiService/cdp.service";

export default function StatsList() {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchStats = async () => {
      setLoading(true);
      try {
        const response = await cdpService.getOverallRegistrationCount();
        const counts = response.data?.data?.registrationCounts || {};
        if (cancelled) return;
        setStats([
          {
            id: 1,
            name: "Total Registrations",
            subname: "All Users",
            stat: counts.totalRegistrationCount?.toLocaleString() || "N/A",
            substat: counts.totalRegistrationCount?.toLocaleString() || "N/A",
            icon: UserGroupIcon,
            bg: "bg-red-50",
            iconcolor: "text-red-500",
          },
          {
            id: 2,
            name: "Migrated Users",
            subname: "Piano Users",
            stat: counts.migratedRegistrationCount?.toLocaleString() || "N/A",
            substat: counts.migratedRegistrationCount?.toLocaleString() || "N/A",
            icon: CursorArrowRippleIcon,
            bg: "bg-green-50",
            iconcolor: "text-green-500",
          },
          {
            id: 3,
            name: "SSO Users",
            subname: "All SSO Users",
            stat: counts.ssoRegistrationCount?.toLocaleString() || "N/A",
            substat: counts.ssoRegistrationCount?.toLocaleString() || "N/A",
            icon: ArrowLeftStartOnRectangleIcon,
            bg: "bg-purple-50",
            iconcolor: "text-purple-500",
          },
        ]);
      } catch (error) {
        if (!cancelled) setStats([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchStats();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) return <SkeletonCard />;

  return stats.map((item) => <StatsCard key={item.id} item={item} />);
}
